import Link from 'next/link';
import styled, { css } from 'styled-components';

import COLORS from 'styles/colors';
import { rem } from 'styles/typography';

const Container = styled.ul`
  padding: 2px;
  display: flex;
  align-items: center;
  border-radius: 25px;
  background-color: ${COLORS.white};
  color: ${COLORS.forest};
`;

const LinkStyled = styled.a`
  padding: 18px 20px;
  border-radius: 25px;
  font-size: ${rem(14)};
  line-height: ${rem(14)};
  font-weight: normal;
  text-decoration: none;

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${COLORS.forest};
      color: ${COLORS.white};
    `}
`;

const Tabs = ({ items, activePath, ...props }) => {
  // TODO: Quick fix will need to change in future to get sessions to be active when on sessions and a sessions specific id
  return (
    <Container {...props}>
      {items.map(({ value, label }) =>
        activePath.includes('/sessions') ? (
          <Link key={value} href={value} passHref>
            <LinkStyled isActive={value === '/my-clays'}>{label}</LinkStyled>
          </Link>
        ) : (
          <Link key={value} href={value} passHref>
            <LinkStyled isActive={value === activePath}>{label}</LinkStyled>
          </Link>
        )
      )}
    </Container>
  );
};

export default Tabs;
